import { useContext, useMemo } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import DeviationMediaService from '../../../utils/DeviationMediaService';
import AttachmentMediaService from '../../../utils/DeviationMediaService/AttachmentMediaService';
/** memoizes potentially expensive deviation media service values */ export function useMediaService(source) {
    const isMobile = useContext(MobileContext);
    const { device } = useContext(SessionContext);
    const attachment = source.fileId ? source : undefined;
    const deviation = attachment ? undefined : source;
    const isGif = useMemo(()=>deviation ? DeviationMediaService.isGif(deviation) : AttachmentMediaService.isGif(attachment), [
        deviation,
        attachment
    ]);
    const isPng = useMemo(()=>deviation ? DeviationMediaService.isPng(deviation) : AttachmentMediaService.isPng(attachment), [
        deviation,
        attachment
    ]);
    const hasSrc = useMemo(()=>deviation ? !!DeviationMediaService.getLargestFullview(deviation) : !!AttachmentMediaService.getLargestFullview(attachment), [
        deviation,
        attachment
    ]);
    const hasPreview = useMemo(()=>deviation ? !!DeviationMediaService.getDeviationFile(deviation, 'preview') : !!AttachmentMediaService.getMediaFile(attachment, 'preview'), [
        deviation,
        attachment
    ]);
    const isPreviewable = hasPreview && hasSrc;
    const screenVw = useMemo(()=>isMobile && !(device === null || device === void 0 ? void 0 : device.isTablet) ? '100vw' : '(min-width: 1152px) 70vw, 100vw', [
        isMobile,
        device
    ]);
    const previewSrcSet = useMemo(()=>isPreviewable ? deviation ? DeviationMediaService.getSrcSetForDeviationPreview(deviation, isMobile, screenVw) : AttachmentMediaService.getSrcSetForAtttachmentPreview(attachment, isMobile, screenVw) : {}, [
        deviation,
        attachment,
        isPreviewable,
        isMobile,
        screenVw
    ]);
    const fullview = useMemo(()=>deviation ? DeviationMediaService.getDeviationFile(deviation, 'fullview') : AttachmentMediaService.getMediaFile(attachment, 'fullview'), [
        deviation,
        attachment
    ]);
    return {
        isPreviewable,
        isGif,
        isPng,
        previewSrcSet,
        fullview
    };
}

//# sourceMappingURL=useMediaService.js.map